var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourArds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67996 17.9366H19.0013L25.9657 17.9364L35.2512 17.9366V12.6627H3.67996V17.9366ZM3.67996 17.9366L10.1799 15.2996H4.60852L18.0727 13.9812H26.8941H32.4655V16.6181H10.1799M2.28711 24.9684L2.28735 12.2232C2.28735 10.2541 2.28745 8.70732 2.28721 7.82834C2.28696 6.94936 2.51655 6.40735 3.21543 6.07026C4.144 6.07039 5.22142 6.07019 7.3016 6.07019H25.9657C28.0459 6.07019 30.6086 6.07013 31.5371 6.07024C32.4657 6.07035 35.7157 5.63085 35.7157 6.94922C35.7157 6.94922 35.7157 9.37501 35.7157 11.3441V30.019C35.7157 30.7124 35.7157 31.0591 35.5807 31.324C35.462 31.557 35.2726 31.7464 35.0397 31.8651C34.7748 32 34.4281 32 33.7347 32H11.5728C9.49258 32 5.53709 32 4.14424 32C3.21567 32 2.28699 30.6817 2.28711 30.2422C2.28723 29.8028 2.28711 26.9375 2.28711 24.9684Z",
    stroke: "#242529",
    strokeWidth: 3.09524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourArds);
export default __webpack_public_path__ + "static/media/Your_сards.901c93b6cb12413babd21141584f3224.svg";
export { ForwardRef as ReactComponent };